import useAuth from "../../auth/accessToken/hooks/useAuth";
import { AuthenticatedAccountUser } from "../../types/management-auth";

const useAccountUser: () => AuthenticatedAccountUser = () => {
    const accountUser = useAuth((state) => state.account_user);
    return accountUser;
};

export default useAccountUser;
